var exports = {
  "k": "TabInline.module__container___WjFMYl",
};

module.exports = exports;
